// KnowledgeBank.Relation — a first-class relation entity.
//
// Per `docs/model/bcs/knowledge-bank.md` §2 + IDD `bd4eafbc`. A relation
// carries its own stable `id` plus a human-facing `name`. The catalogue
// (`KnowledgeBankState.relations: Map<RelationId, Relation>`) is the
// relation vocabulary; assertions reference relations by `id`, so a
// rename or merge is a single event over the stable id, never a rewrite
// of every citing triple.
//
// Post-MVP metadata (description, inverse, symmetry) attaches here — the
// payoff of reifying — without reshaping any triple.
export { mkRelation, seededRelations };
import * as RelationId from "./relationId.js";
import * as RelationName from "./relationName.js";
const mkRelation = (id, name) => ({ id, name });
// === Seeded vocabulary ===
//
// The starting relation catalogue (name list from `knowledge-bank.md`
// §8 plus the MVP-PM reification targets). Each seeds a `Relation` with
// the deterministic `forName` id. `initial` KB state installs these as a
// runtime invariant (layer default) so the vocabulary always exists —
// no `relation_defined` event is needed for a seeded relation, and a
// migrated legacy `assertion_added` resolves its `relationId` against a
// catalogue that already holds the name.
const SEEDED_NAMES = [
    RelationName.teaches,
    RelationName.covers,
    RelationName.touches,
    RelationName.prerequisiteOf,
    RelationName.derivesFrom,
    RelationName.serves,
    RelationName.hasDescription,
    RelationName.hasTag,
    RelationName.hasQualityScore,
    RelationName.contradicts,
    RelationName.supports,
    RelationName.annotates,
    RelationName.hasActor,
    RelationName.citesElement,
    RelationName.answersTo,
    RelationName.definedIn,
    RelationName.explains,
    RelationName.practises,
    RelationName.broader,
    RelationName.drawsOn,
    RelationName.related,
    RelationName.schemaText,
    RelationName.schemaAbout,
    RelationName.schemaAudience,
    RelationName.provWasAttributedTo,
    RelationName.provGeneratedAtTime,
    RelationName.provWasDerivedFrom,
    RelationName.oaHasSource,
    RelationName.oaHasSelector,
    RelationName.oaExact,
    RelationName.oaPrefix,
    RelationName.oaSuffix,
    RelationName.oaStart,
    RelationName.oaEnd,
    RelationName.rdfValue,
];
const seededRelations = SEEDED_NAMES.map((name) => mkRelation(RelationId.forName(name), name));
//# sourceMappingURL=relation.js.map